import styled from "styled-components"
import colors from "../../utils/style/colors.tsx"
import Carte from "../../assets/images/carte.png"
import Site from "../../assets/images/site.png"
import Ordi from "../../assets/images/ordi.png"

const CardWrapper = styled.div`
    background-color: ${colors.white};
    position: relative;
    border-radius: 15px;
    padding: 20px;
    margin: 15px;
    text-align: left;
    border: solid 5px ${colors.black};
    transition: all ease 0.3s;
    width: 290px;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 15px;
        background-color: ${({ color }) => color};
        z-index: -1;
        box-shadow: 13px 13px ${colors.black};
    }
        
    &:hover{
        transition: all ease 0.3s;
        transform: translate(-5px, -5px);
    }


    @media (max-width: 1000px) {
        width: 215px;

        &::before {
            box-shadow: 8px 13px ${colors.black};
        }
    }
`

const TitleWrapper = styled.div``

const CardTitle = styled.h2`
    font-family: "Archivo Black", sans-serif;
    font-size: 31px;
    margin-bottom: 10px;
    color: ${colors.white};
    text-shadow: 3px 3px ${colors.black};
    -webkit-text-stroke-color: ${colors.black};
    -webkit-text-stroke-width: 1px;
    margin-top: 10px;
    align-content: center;
    min-height: 60px;
    
    @media (max-width: 1050px) {
        min-height: 85px;
    }

    @media (max-width: 950px) {
        min-height: 50px;
        font-size: 22px;
        text-shadow: 2px 2px ${colors.black};
    }
    
`

const CardText = styled.p`
    font-family: "Archivo", sans-serif;
    font-size: 22px;
    margin-bottom: 10px;
    min-height: 50px;
    align-content: center;
    line-height: 37px;

    @media (max-width: 1440px) {
        min-height: 70px;
    }


    @media (max-width: 950px) {
        font-size: 16px;
        line-height: 27px;
    }
`

const ImgWrapper = styled.div`
    height: 105px;
    display: flex;
    align-items: center;

    @media (max-width: 950px) {
        height: unset;
    }
`

const StyledImgCarte = styled.img`
    width: 143px;
    height: 74px;

    @media (max-width: 950px) {
        width: 83px;
        height: 44px;
    }
`;

const StyledImgSite = styled.img`
    width: 126px;
    height: 89px;

    @media (max-width: 950px) {
        width: 71px;
        height: 51px;
    }
`;

const StyledImgOrdi = styled.img`
    width: 102px;
    height: 102px;

    @media (max-width: 950px) {
        width: 72px;
        height: 72px;
    }
`;




function CardServices({ page }) {
    return (
        <>
            {page === "design" && (
                <CardWrapper>
                    <TitleWrapper>
                        <ImgWrapper>
                            <StyledImgCarte src={Carte} alt="design" style={{ width: "143px", height: "74px" }} />
                        </ImgWrapper>
                        <CardTitle>Design</CardTitle>
                        <CardText>Je suis capable de concevoir différents design. J’ai déjà réalisé plusieurs logos, cartes de visites ainsi que des flyers pour des entreprises de domaines variés.</CardText>
                    </TitleWrapper>
                </CardWrapper>
            )}


            {page === "site" && (
                <CardWrapper>
                    <TitleWrapper>
                        <ImgWrapper>
                            <StyledImgSite src={Site} alt="site" style={{ width: "126px", height: "89px" }} />
                        </ImgWrapper>
                        <CardTitle>Site Web</CardTitle>
                        <CardText>Lorsque je développe un site web, je commence par une maquette pour valider la première étape avec vous. J’adapte le site à vos besoins tout au long du projet. J’ai eu l’occasion de réaliser quelques sites web de A à Z.</CardText>
                    </TitleWrapper>
                </CardWrapper>
            )}


            {page === "projet" && (
                <CardWrapper>
                    <TitleWrapper>
                        <ImgWrapper>
                            <StyledImgOrdi src={Ordi} alt="projets" style={{ width: "102px", height: "102px" }} />
                        </ImgWrapper>
                        <CardTitle>Projets Web</CardTitle>
                        <CardText>J'ai réalisé divers projets web durant mes études, créant des logiciels avec PHP, JavaScript, HTML et CSS. J'ai ensuite appris React et utilisé Prestashop et PHP lors de ma première année d'expérience.</CardText>
                    </TitleWrapper>
                </CardWrapper>
            )}
        </>
    )
}

export default CardServices
